import React, { memo, useMemo } from 'react';
import * as Styled from './styled';
import {
  StyledText,
  SelectOption,
} from '@leasequery/lq.react-component-library';
import { StringOrComponent } from '../../../models';

const DEFAULT_LABELS = {
  itemCount: 'Count:',
  perPage: 'Per Page',
  showing: 'Showing',
};

const ITEM_PER_PAGE_OPTIONS: SelectOption<number>[] = [
  { key: 10, label: '10', value: 10 },
  { key: 25, label: '25', value: 25 },
  { key: 50, label: '50', value: 50 },
  { key: 100, label: '100', value: 100 },
];

interface TablePageSizerProps {
  itemCount: number;
  pageSize: number;
  pageIndex: number;
  labels: {
    itemCount?: StringOrComponent;
    perPage?: string;
    showing?: string;
  };
  onChange?: (item: SelectOption<number>) => void;
}

function TablePageSizer({
  itemCount,
  pageSize,
  pageIndex,
  labels,
  onChange,
}: TablePageSizerProps): JSX.Element {
  const labelsText = useMemo(() => ({ ...DEFAULT_LABELS, ...labels }), [
    labels,
  ]);
  const pageSizeSelectOption = ITEM_PER_PAGE_OPTIONS.find(
    (opt) => opt.value === pageSize,
  );
  const fromIndex = pageIndex * pageSize;
  const toIndex = Math.min(fromIndex + pageSize, itemCount);

  return (
    <Styled.TablePageSizer>
      {typeof labelsText.itemCount === 'string' ? (
        <div>
          <StyledText>{labelsText.itemCount}&nbsp;</StyledText>
          <StyledText fontWeight="bold">{itemCount}</StyledText>
        </div>
      ) : (
        <>{labelsText.itemCount}</>
      )}
      <div>
        <Styled.PageSizeSelect
          name="ItemPerPage"
          options={ITEM_PER_PAGE_OPTIONS}
          onChange={onChange}
          value={pageSizeSelectOption}
        />
        <StyledText>&nbsp;{labelsText.perPage}</StyledText>
      </div>
      {itemCount > 0 && (
        <StyledText>
          {`${labelsText.showing} ${fromIndex + 1}-${toIndex}`}
        </StyledText>
      )}
    </Styled.TablePageSizer>
  );
}

export default memo(TablePageSizer);
